export default __webpack_public_path__ + "static/media/cabinet1-before-480w.3690a57f.png";